import axios from 'axios'

const API_PATH = 'api/v2/admins/customers/shipment_methods'

const ShipmentMethodsApiV2 = {
  /**
   * Get list of `Shipment Method`
   * @param {object} params uri parameter
   * @return {object} Collection of `Shipment Methods`
   */
  get: async () => {
    const path     = `${API_PATH}`
    const response = axios.get(path)
    return response
  }
}

export default ShipmentMethodsApiV2
